






























import { CompanyGoToHelper } from "@/lib/utility/company.go-to-helper";
import { PersonGoToHelper } from "@/lib/utility/person.go-to-helper";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IInvoiceParty } from "@/models/invoice-party.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {},
  filters: {}
})
export default class InvoicePartySheet extends mixins(PermissionMixin) {
  @Prop()
  invoiceParty!: IInvoiceParty;

  @Prop({ default: "grey lighten-4" })
  color!: string;

  @Prop({ default: false, type: Boolean })
  hideDetails!: boolean;

  get partnerId() {
    return PartnerModule.partner?.id || "";
  }

  get hasRef() {
    if (!this.invoiceParty.ref?.refType || !this.invoiceParty.ref?.refId) {
      return false;
    }

    if (
      this.invoiceParty.ref.refType === ResourceEnum.COMPANY ||
      this.invoiceParty.ref.refType === ResourceEnum.PERSON
    ) {
      return true;
    }

    return false;
  }

  goToParty(party: IInvoiceParty) {
    if (!party.ref?.refId || !party.ref?.refType || !this.partnerId) {
      return;
    }

    if (party.ref.refType === ResourceEnum.COMPANY) {
      new CompanyGoToHelper(this.$router).goToCompanyDetail({
        partnerId: this.partnerId,
        companyId: party.ref.refId,
        newTab: false
      });

      return;
    } else if (party.ref.refType === ResourceEnum.PERSON) {
      new PersonGoToHelper(this.$router).goToPersonDetail({
        partnerId: this.partnerId,
        personId: party.ref.refId,
        newTab: false
      });
      return;
    }

    this.$emit("goToParty", party);
  }
}
